import type React from 'react';

import { Card, CardBody, CardHeader, Text } from '@change/ds-core-ui';

import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { IconTile } from '#src/app/pages/about/shared/components';

import type { JourneyStepType } from '../../consts';

export const JourneyCard: React.FC<JourneyStepType> = ({ Icon, number, title, body }) => {
	return (
		<Card className="bg-background-base content-start rounded-2xl">
			<CardHeader>
				<div className="flex items-center justify-between">
					<IconTile Icon={Icon} size="medium" data-qa="vision-journey-icon-tile" />
					<Text size="small" fontWeight="bold" className="text-typography-weak">
						<TypedTranslate value={number} />
					</Text>
				</div>
			</CardHeader>
			<CardBody className="flex flex-col gap-2">
				<Text as="h3" variant="heading" size="x-small">
					<TypedTranslate value={title} />
				</Text>
				<Text as="p" size="small" className="text-typography-weak">
					<TypedTranslate value={body} />
				</Text>
			</CardBody>
		</Card>
	);
};
